module.exports = "pegasus_template/assets/tech/medium/3.jpg";